import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getCatalog, getLenguajes } from '../api/client';

/** Páginas .aspx del sitio viejo -> tipo de test nuevo. */
const TYPE_BY_PAGE = {
  libretesttest: 'libretest',
  rotaciontest: 'rotacion',
  primingtest: 'priming',
  digitosdirectosinversostest: 'digitosdirectosinversos',
  memoriaevocacionreconoctest: 'memoriaacortopalabras',
  aprendizajesuperficialprofundo: 'aprendizajesuperficialprofundo',
};

/**
 * Puente para links viejos tipo /WebFormTest/LibreTestTest.aspx?ID=123&tt=45
 * (no se pueden resolver con redirects de Firebase porque dependen de query params).
 * Busca la tarea (tt) en el catálogo y lleva al ejercicio o a la tarea nueva.
 */
export default function LegacyRedirect() {
  const { page } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const testId = searchParams.get('ID') || searchParams.get('id');
    const tareaId = Number(searchParams.get('tt'));
    const type = TYPE_BY_PAGE[String(page ?? '').replace(/\.aspx$/i, '').toLowerCase()];

    if (!tareaId) {
      navigate('/', { replace: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const lenguajes = await getLenguajes();
        const catalogs = await Promise.all(
          lenguajes.map((l) => getCatalog(l.ID).catch(() => null)),
        );
        if (cancelled) return;

        for (let i = 0; i < catalogs.length; i += 1) {
          const catalog = catalogs[i];
          if (!catalog) continue;
          for (const categoria of catalog.categorias ?? []) {
            const tarea = (categoria.tareas ?? []).find((t) => t.ID === tareaId);
            if (!tarea) continue;
            const base = `/lenguaje/${lenguajes[i].ID}/categoria/${categoria.ID}/tarea/${tarea.ID}`;
            navigate(testId && type ? `${base}/test/${type}/${testId}` : base, { replace: true });
            return;
          }
        }
        navigate('/', { replace: true });
      } catch {
        if (!cancelled) navigate('/', { replace: true });
      }
    })();

    return () => { cancelled = true; };
  }, [page, searchParams, navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <p className="text-slate-600">Redirigiendo...</p>
    </div>
  );
}
